import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Input } from "antd";
import React, { useState } from "react";
import { FaEnvelope } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../../css/JuanIS/ForgotPasswordOfficial.css";
import SJDEFILogo from "../../images/SJDEFILogo.png";
import Footer from "../UserAdmin/Footer";

const ForgotPasswordOfficial = () => {
  const navigate = useNavigate();

  const [employeeID, setEmployeeID] = useState("");
  const [errors, setErrors] = useState({});
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const validateInput = () => {
    if (!employeeID) {
      setErrors({ employeeID: "Employee ID is required" });
      return false;
    }
    const employeeIDRegex = /^\d{2}-\d{5}$/;
    if (!employeeIDRegex.test(employeeID)) {
      setErrors({ employeeID: "Invalid Employee ID format (e.g., 25-12345)" });
      return false;
    }
    setErrors({});
    return true;
  };

  const handleRequestOTP = async () => {
    if (!validateInput()) return;
    setLoading(true);

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/faculty/forgot-password-otp`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Content-Type-Options": "nosniff",
          "X-XSS-Protection": "1; mode=block",
        },
        body: JSON.stringify({ employeeID: employeeID.trim() }),
      });

      const data = await response.json();

      if (!response.ok) {
        if (data.errorType === "account_inactive") {
          setMessage("Account is inactive. Please contact the admin.");
          toast.error("Account is inactive.");
        } else if (data.errorType === "account_pending") {
          setMessage("Account is pending verification.");
          toast.error("Account is pending verification.");
        } else if (data.errorType === "account_not_found") {
          setMessage("Account not found.");
          toast.error("Account not found.");
        } else {
          setMessage(data.message || "Failed to send OTP.");
          toast.error("Failed to send OTP.");
        }
        return;
      }

      toast.success("Verification code sent to your email.");
      navigate("/juanis-verify-otp", {
        state: {
          email: data.email,
          employeeID: employeeID,
          firstName: data.firstName,
          fromForgotPassword: true,
        },
      });
    } catch (error) {
      console.error("OTP request error:", error);
      setMessage("Failed to connect to the server.");
      toast.error("Failed to connect to the server.");
    } finally {
      setLoading(false);
    }
  };

  const handleGoToLogin = () => {
    navigate("/juan-is-login");
  };

  const handleGoToHome = () => {
    navigate("/home");
  };

  return (
    <div className="fpo-main-container">
      <ToastContainer />
      <div className="fpo-login-container" style={{ borderRadius: '15px' }}>
        <div className="fpo-left-box" style={{borderTopLeftRadius: '15px', borderBottomLeftRadius: '15px'}}>
          <img src={SJDEFILogo} alt="SJDEFI Logo" className="fpo-admin-logo" />
          <div className="fpo-header-text">
            <h1>SJDEFI</h1>
            <p className="fpo-motto">
              Where faith and reason are expressed in Charity.
            </p>
          </div>
          <h1 className="fpo-login-title">Information System Portal</h1>
        </div>
        <div className="fpo-right-box" style={{borderTopRightRadius: '15px', borderBottomRightRadius: '15px'}}>
          <h1 className="fpo-login-title">Forgot Password</h1>
          <p className="fpo-login-subtitle">
            Enter your Employee ID to receive a password reset code
          </p>
          <label className="fpo-input-label">Employee ID</label>
          <Input
            className="fpo-custom-input"
            addonBefore={<FaEnvelope />}
            placeholder="Enter Employee ID (e.g., 25-12345)"
            value={employeeID}
            onChange={(e) => setEmployeeID(e.target.value)}
            status={errors.employeeID ? "error" : ""}
          />
          {errors.employeeID && (
            <div className="fpo-error-message">{errors.employeeID}</div>
          )}
          {message && <div className="fpo-error-message">{message}</div>}
          <div className="fpo-login-options">
            <Button
              type="link"
              onClick={handleGoToHome}
              className="fpo-nav-button"
            >
              Go Back to Home
            </Button>
            <Button
              type="link"
              onClick={handleGoToLogin}
              className="fpo-nav-button"
            >
              Back to Login
            </Button>
          </div>
          <Button
            type="ghost"
            className="fpo-login-btn"
            onClick={handleRequestOTP}
            disabled={loading}
          >
            {loading ? (
              <>
                <FontAwesomeIcon
                  icon={faSpinner}
                  spin
                  className="fpo-spinner-icon"
                />
                <span>Processing...</span>
              </>
            ) : (
              "Request Reset Code"
            )}
          </Button>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ForgotPasswordOfficial;